import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';

export const isBaseLogoutRequest = (path: string): boolean => {
  const [pathname, query = ''] = path.split('?', 2);
  const isBasePath = pathname === '' || pathname === '/';

  return isBasePath && new URLSearchParams(query).get('logout') === 'true';
};

export const baseLogoutRedirect: RedirectFunction = (route) => {
  if (route.queryParamMap.get('logout') === 'true') {
    return inject(Router).createUrlTree(
      ['/user/applications'],
      { queryParams: { logout: 'true' } }
    );
  }

  return '/login';
};
